import React from "react";
import { useUserContext } from "context/UserContext";
import KeyMetricsBK from "layouts/BK/keyMetrics";
import { isBkLikeRole } from "utils/roleUtils";

function KeyMetrics() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <KeyMetricsBK />;
  }
  return null;
}

export default KeyMetrics;
